import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Container, ContentContainer, Image, ImageSection, Section, SectionHeader, TextSection } from '../styles';
import { Header } from './header';
import { usePublicSettings } from '../shared/contexts/PublicSettingsContext';
import jillAndLuke from '../../src/images/jill_and_luke.jpg';
import styled from 'styled-components';

const MarkdownContent = styled.div`
    & p {
        margin-bottom: 1em;
        line-height: 1.6;
    }
    
    & h1, & h2, & h3, & h4, & h5, & h6 {
        margin-top: 1.5em;
        margin-bottom: 0.5em;
        font-weight: 600;
    }
    
    & h1 { font-size: 2em; }
    & h2 { font-size: 1.5em; }
    & h3 { font-size: 1.25em; }
    
    & ul, & ol {
        margin-left: 1.5em;
        margin-bottom: 1em;
    }
    
    & li {
        margin-bottom: 0.5em;
    }
    
    & strong {
        font-weight: 600;
    }
    
    & em {
        font-style: italic;
    }
    
    & a {
        color: #007bff;
        text-decoration: none;
        
        &:hover {
            text-decoration: underline;
        }
    }
    
    & code {
        background-color: #f4f4f4;
        padding: 2px 6px;
        border-radius: 3px;
        font-family: 'Courier New', monospace;
        font-size: 0.9em;
    }
    
    & pre {
        background-color: #f4f4f4;
        padding: 1em;
        border-radius: 6px;
        overflow-x: auto;
        margin-bottom: 1em;
        
        & code {
            background-color: transparent;
            padding: 0;
        }
    }
    
    & blockquote {
        border-left: 4px solid #ddd;
        padding-left: 1em;
        margin-left: 0;
        color: #666;
        font-style: italic;
    }
`;

export const About = () => {
    const { settings, loading, error } = usePublicSettings();

    if (loading) {
        return (
            <Container>
                <Header/>
                <Section>
                    <SectionHeader>About</SectionHeader>
                    <ContentContainer>
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            Loading content...
                        </div>
                    </ContentContainer>
                </Section>
            </Container>
        );
    }

    if (error) {
        return (
            <Container>
                <Header/>
                <Section>
                    <SectionHeader>About</SectionHeader>
                    <ContentContainer>
                        <div style={{ textAlign: 'center', padding: '50px', color: '#721c24' }}>
                            Error loading content. Please try again later.
                        </div>
                    </ContentContainer>
                </Section>
            </Container>
        );
    }

    const aboutContent = settings.aboutContent || '';

    return (
        <Container>
            <Header/>
            <Section>
                <SectionHeader>About</SectionHeader>
                <ContentContainer>
                    <ImageSection>
                        <Image src={jillAndLuke} alt="Jill and Luke"/>
                    </ImageSection>
                    <TextSection>
                        {aboutContent ? (
                            <MarkdownContent>
                                <ReactMarkdown 
                                    remarkPlugins={[remarkGfm]}
                                    components={{
                                        a: ({ ...props }) => (
                                            <a {...props} target="_blank" rel="noopener noreferrer" />
                                        ),
                                    }}
                                >
                                    {aboutContent}
                                </ReactMarkdown>
                            </MarkdownContent>
                        ) : (
                            <p>About content is not available.</p>
                        )}
                    </TextSection>
                </ContentContainer>
            </Section>
        </Container>
    );
}